// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2ADs_","title":"ClientReferral_title__1SIei","itemText":"ClientReferral_itemText__1ZNJh"};